// どの種別の電車が、どのレーンを走るのかを返す
class TrainLaneData {
  // 駅に停車中はその駅IDを与えればよい
  // 駅間はnextStationIdを与えればよい
  static getLane = (train, stationId) => {
    const stationIdInt = parseInt(stationId, 10)
    if (train.line_id === 1 && 11 <= stationIdInt && stationIdInt <= 19) {
      // 本線で希望ヶ丘〜海老名までは、特急・通勤特急のみ外側
      switch(train.train_kind_id.toString()) {
        case '0':
        case '5':
        case '8':
          return 'outer'
        default:  return 'inner'
      }
    } else if (train.line_id === 4) {
      // JR線直通関係は特急のみ外側
      switch(train.train_kind_id.toString()) {
        case '0':
        case '8':
          return 'outer'
        default:  return 'inner'
      }
    } else if (train.line_id === 3) {
      if ((stationIdInt >= 68 && stationIdInt <= 74) || (stationIdInt >= 118 && stationIdInt <= 124) || (train.direction === 'down' && train.nextStationId === 62)){ // 東急線直通の田園調布以北は種別にかかわらずすべて内側
        return 'inner'
      } else if (stationIdInt >= 62 && stationIdInt <= 67) { // 田園調布〜日吉は東横線が外側
        if (train.train_line_id === 26001) {
          return 'outer'
        } else {
          return 'inner'
        }
      } else {
        // それ以外は優等が外側
        switch(train.train_kind_id.toString()) {
          case '4': return 'inner'
          default:  return 'inner'
        }
      }
    } else {
      // それ以外は優等が外側
      switch(train.train_kind_id.toString()) {
        case '4': return 'inner'
        default:  return 'outer'
      }
    }
  }
}

export default TrainLaneData
